<template>
  <div class="main-wrapper">
    <div class="animate-circule">
      <canvas ref="canvas" :width="size.w" :height="size.h"></canvas>
    </div>
    <div class="shape-bottom">
      <img
        ref="degShape"
        :src="require('@/assets/world-page/world-page-bottom-circle.svg')"
      />
    </div>
    <div class="customers">
      <div class="customers__people">
        <i class="fas fa-users"></i>
      </div>
      <div class="customers__title">
        {{ $t("world.world_population") }}:
        <span class="customers__numbers">{{
          population.toLocaleString().replace(/,/g, " ")
        }}</span>
      </div>
    </div>
    <div class="grid">
      <div class="grid__left">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list.slice(0, desktopWidthNews ? 2 : 1)"
          :key="item.id"
        >
          <div class="left-news" :class="`left-news-${index}`">
            <div class="left-news__img">
              <div class="left-news__category">
                <div class="region" style="font-weight: 500">
                  {{ newsCountries[item.id] }}
                </div>
                <div>
                  {{ item.sub_category.name }}
                </div>
              </div>
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div>
              <h2
                class="left-news__title title-news limited-text"
                style="--snup: 2"
              >
                {{ item.title }}
              </h2>
              <div class="left-news__descr limited-text" style="--snup: 6">
                {{ item.brief }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="grid__center">
        <div class="arrow-left" @click="openEarth">
          <svg
            width="31"
            height="33"
            viewBox="0 0 31 33"
            fill="none"
            style="display: block"
            :class="visibleEarth ? 'hidden-arrow' : ''"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.4215 0.211099C16.7064 -0.0641028 17.1604 -0.0561688 17.4356 0.228715C17.7041 0.506673 17.7041 0.947278 17.4356 1.22517L2.16507 16.4971L17.4371 31.7677C17.7219 32.0429 17.7299 32.4969 17.4547 32.7819C17.1795 33.0667 16.7255 33.0746 16.4405 32.7995C16.4346 32.7937 16.4287 32.7878 16.4229 32.7819L0.644571 17.0035C0.364595 16.7235 0.364595 16.2695 0.644571 15.9894L16.4215 0.211099Z"
              fill="#FFFFFF"
            />
            <path
              d="M13.5526 15.9894L29.331 0.211099C29.6158 -0.0641028 30.0699 -0.0561688 30.3451 0.228715C30.6135 0.506673 30.6135 0.947279 30.3451 1.22524L15.0745 16.4972L30.3465 31.7677C30.6314 32.0429 30.6393 32.4969 30.3641 32.7819C30.0889 33.0667 29.6349 33.0746 29.35 32.7995C29.344 32.7937 29.3382 32.7878 29.3324 32.7819L13.554 17.0035C13.2737 16.7239 13.273 16.2699 13.5526 15.9894Z"
              fill="#FFFFFF"
            />
          </svg>
        </div>
        <div
          class="earth_cont"
          :style="visibleEarth ? 'transform: translateX(-50%);' : ''"
          ref="earthcontainer"
        ></div>
      </div>
      <div class="grid__right">
        <div class="wrapper-right" :class="visibleEarth ? 'hidden-block' : ''">
          <template v-for="(item, index) in list.slice(0, 3)" :key="item.id">
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: item.url }
                })
              "
            >
              <div class="right-news" :class="`right-news-${index} `">
                <div class="right-news__category">
                  {{ item.sub_category.name }}
                </div>
                <div class="flex-mobile">
                  <div class="right-news__img">
                    <ImageContainer
                      class="img"
                      :src="item.image.medium"
                      :thumb="item.image.thumbnail"
                      :alt="item.title"
                    />
                  </div>
                  <div class="right-news__title">
                    <h3 class="limited-text">
                      {{ item.title }}
                    </h3>
                    <div class="data-news">
                      <span class="day">{{ handleDate(item.pub_date) }},</span>
                      <span class="time">{{ handleTime(item.pub_date) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </template>
        </div>
      </div>
    </div>
    <div class="news-bottom">
      <template
        v-for="(item, index) in list.slice(desktopWidthNews ? 2 : 3, 7)"
        :key="item.id"
      >
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          class="news"
          :class="`news-bottom-${index}`"
        >
          <div class="news__category">
            {{ item.sub_category.category.name }}
          </div>
          <div class="news__container">
            <div class="news__img">
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>

            <div class="news__info">
              <h4 class="news__title limited-text" style="--snup: 3">
                {{ item.title }}
              </h4>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";
import { useStore } from "vuex";
import { reactive, ref, nextTick, watch } from "vue";
import { onBeforeUnmount, onMounted, computed } from "vue";
import { countries } from "@/utils/constants";
import layer2 from "@/assets/world-page/svg-centrer-animate/Layer 2.svg";
import layer3 from "@/assets/world-page/svg-centrer-animate/Layer 3.svg";
import layer4 from "@/assets/world-page/svg-centrer-animate/Layer 4.svg";
import layer5 from "@/assets/world-page/svg-centrer-animate/Layer 5.svg";
import layer6 from "@/assets/world-page/svg-centrer-animate/Layer 6.svg";
import layer7 from "@/assets/world-page/svg-centrer-animate/Layer 7.svg";
import layer8 from "@/assets/world-page/svg-centrer-animate/Layer 8.svg";
import layer9 from "@/assets/world-page/svg-centrer-animate/Layer 9.svg";
import layer10 from "@/assets/world-page/svg-centrer-animate/Layer 10.svg";
import layer11 from "@/assets/world-page/svg-centrer-animate/Layer 11.svg";
import layer12 from "@/assets/world-page/svg-centrer-animate/Layer 12.svg";
import layer13 from "@/assets/world-page/svg-centrer-animate/Layer 13.svg";
import layer14 from "@/assets/world-page/svg-centrer-animate/Layer 14.svg";
import layer15 from "@/assets/world-page/svg-centrer-animate/Layer 15.svg";
import layer16 from "@/assets/world-page/svg-centrer-animate/Layer 16.svg";
import layer17 from "@/assets/world-page/svg-centrer-animate/Layer 17.svg";
import layer18 from "@/assets/world-page/svg-centrer-animate/Layer 18.svg";
import layer19 from "@/assets/world-page/svg-centrer-animate/Layer 19.svg";

export default {
  name: "MainBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const newList = ref(props.list ?? []);
    const { moveArrayItemToNewIndex } = useFormatter();
    let degShape = ref(null);
    let degCircule = 0;
    let changeDeg = 110;
    const desktopWidthNews = ref(false);
    let animate = false;

    let canvas = ref(null);
    let size = reactive({
      w: 800,
      h: 800
    });

    function loadImages(sources, callback) {
      var images = {};
      var loadedImages = 0;
      var numImages = 0;
      // get num of sources
      for (var src in sources) {
        numImages++;
      }
      for (src in sources) {
        images[src] = new Image();
        images[src].onload = function() {
          if (++loadedImages >= numImages) {
            callback(images);
          }
        };
        images[src].src = sources[src];
      }
    }

    const checkWidth = () => {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 992) {
          desktopWidthNews.value = true;
        }
        if (window.innerWidth >= 425) {
          visibleEarth.value = false;
        }
        if (window.innerWidth < 992) {
          // mainInterval = setInterval(handleNewsChange, 4000);
          if (mainInterval) clearInterval(mainInterval);
        }
      }
    };
    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }
    let mainInterval;
    onMounted(() => {
      if (typeof window !== "undefined") {
        animate = true;
        visibleEarth.value;
        if (window.innerWidth >= 992) {
          gotoBreakingNews(newList.value[0].id);
          mainInterval = setInterval(handleNewsChange, 6000);
        }
      }
      window.addEventListener("resize", resizeThrottler, false);
      resizeThrottler();

      let ctx = canvas.value.getContext("2d");
      var sources = {
        image1: layer2,
        image2: layer3,
        image3: layer4,
        image4: layer5,
        image5: layer6,
        image6: layer7,
        image7: layer8,
        image8: layer9,
        image10: layer10,
        image11: layer11,
        image12: layer12,
        image14: layer13,
        image15: layer14,
        image16: layer15,
        image17: layer16,
        image18: layer17,
        image19: layer18,
        image20: layer19
      };

      let angle = 0;

      const rotateAngles = [
        0.1,
        -0.3,
        0.2,
        0.1,
        0.4,
        -0.2,
        0,
        -0.21,
        0.3,
        0.31,
        -0.1,
        0.2,
        0.01,
        0.35,
        0,
        -1
      ];

      const drawImg = images => {
        ctx.clearRect(0, 0, canvas.value.width, canvas.value.height);
        let i = 0;
        for (const imgIndex in images) {
          ctx.save(); // save context
          ctx.translate(canvas.value.width / 2, canvas.value.height / 2);
          ctx.rotate((angle * rotateAngles[i] * Math.PI) / 180);
          ctx.translate(
            -images[imgIndex].width / 2,
            -images[imgIndex].height / 2
          );
          i++;
          ctx.drawImage(images[imgIndex], 0, 0);
          ctx.restore(); // restore to initial coordinates
        }
        angle = angle + 1;

        if (typeof window !== "undefined" && animate)
          window.requestAnimationFrame(() => drawImg(images));
      };
      mainInterval;

      loadImages(sources, function(images) {
        if (typeof window !== "undefined" && animate)
          window.requestAnimationFrame(() => drawImg(images));
      });
    });

    onBeforeUnmount(() => {
      if (mainInterval) clearInterval(mainInterval);
      window.removeEventListener("resize", resizeThrottler);
    });

    if (typeof window !== "undefined") {
      if (window.innerWidth > 992) {
        desktopWidthNews.value = true;
      }
    }

    let earthcontainer = ref(null);
    // let overlayMarkers = [];
    let remoteMarkers = [];
    let locList = [];
    let remoteMapStyles = "";
    let earth;
    let visibleEarth = ref(false);
    const newsCountries = ref([]);

    const setEarth = async () => {
      if (typeof window !== "undefined") {
        for (const article of props.list) {
          for (const tag of article.tags) {
            try {
              const coordData = tag.slug.split(",");
              if (coordData.length === 3 && coordData[0] in countries) {
                coordData.push(article.id);
                remoteMarkers.push(coordData);
                remoteMapStyles += `#${coordData[0]}, `;
                newsCountries.value[article.id] = tag.name;
              }
              /* eslint-disable no-empty */
            } catch {}
            /* eslint-enable */
          }
        }

        remoteMapStyles = remoteMapStyles.slice(0, -2);

        await nextTick();

        /* eslint-disable no-undef */
        earth = new Earth(earthcontainer.value, {
          /* eslint-enable no-undef */
          location: { lat: 39.77472, lng: 64.42861 },
          zoom: 1.05,
          light: "none",

          transparent: true,
          mapSeaColor: "RGBA(41,70,60,0.50)",
          mapLandColor: "#4D7E6B",
          mapBorderColor: "#84938E",
          mapBorderWidth: 0.25,
          // mapStyles: `${remoteMapStyles}{ fill: #8AC4B1; stroke: #84938E; } `,
          mapHitTest: true,
          autoRotate: true,
          autoRotateSpeed: 1.7,
          autoRotateDelay: 2000
        });

        for (const marker of remoteMarkers) {
          locList.push(
            earth.addOverlay({
              location: { lat: marker[1], lng: marker[2] },
              offset: 0.3,
              depthScale: 0.25,
              className: "earth-news",
              occlude: false,
              elemId: marker[3]
            })
          );
        }

        // overlayMarkers[0] = earth.addOverlay({
        //   location: { lat: 80, lng: 91 },
        //   offset: 0.3,
        //   depthScale: 0.25,
        //   className: "earth-news",
        //   occlude: false,
        //   newsId: 1,
        // });
        // overlayMarkers[2] = earth.addOverlay({
        //   location: { lat: 50, lng: 10 },
        //   offset: 0.3,
        //   depthScale: 0.25,
        //   className: "earth-news",
        //   occlude: false,
        //   newsId: 2,
        // });
      }
    };

    function gotoBreakingNews(elemId) {
      if (earth) {
        locList.forEach(loc => {
          if (loc.elemId === elemId) {
            earth.goTo(loc.location, { duration: 250, relativeDuration: 70 });
            loc.element.style.opacity = "1";
          } else {
            loc.element.style.opacity = "0";
            loc.element.style.transition = "all 0.4s ease";
            earth.mapStyles = "#US { fill: #8AC4B1; stroke: #84938E; }";
          }
        });
      }
    }

    const handleNewsChange = async (dir = 1) => {
      if (dir === 1) {
        newList.value = moveArrayItemToNewIndex(
          newList.value,
          0,
          newList.value.length - 1
        );
      } else {
        newList.value = moveArrayItemToNewIndex(
          newList.value,
          newList.value.length - 1,
          0
        );
      }
      degCircule = degCircule + changeDeg;
      degShape.value.style.transform = `rotate(${degCircule}deg)`;

      gotoBreakingNews(newList.value[0].id);
    };

    watch(
      () => props.list,
      () => setEarth(),
      { immediate: true }
    );

    const openEarth = () => {
      visibleEarth.value = !visibleEarth.value;
    };

    const populationDiff = ref(0);
    store.dispatch("population");
    let populationInterval;
    onMounted(() => {
      if (populationInterval) clearInterval(populationInterval);
      if (typeof window !== "undefined") {
        populationInterval = setInterval(() => {
          populationDiff.value = Math.floor(Math.random() * 1200);
        }, 500);
      }
    });

    onBeforeUnmount(() => {
      if (populationInterval) clearInterval(populationInterval);
    });

    return {
      ...useFormatter(),
      population: computed(
        () => store.getters.populationNum - populationDiff.value
      ),
      earth,
      earthcontainer,
      openEarth,
      visibleEarth,
      degShape,
      desktopWidthNews,
      canvas,
      size,
      newsCountries
    };
  }
};
</script>

<style lang="scss">
.earth-occluded {
  .earth-news {
    opacity: 0.6;
  }
}
</style>

<style lang="scss" scoped>
$green: #447562;
$bg-white: #f4fffb;

.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}

.flex-mobile {
  @media screen and (max-width: 767px) {
    display: flex;
  }
}
.hidden-arrow {
  transition: transform 0.5s ease-in;
  transform: scale(-1, 1);
}
.earth-center {
  transform: translateX(-50%);
}
.hidden-block {
  transition: all 0.5s ease-in;
  transform: translateX(-200%);
}

.main-wrapper {
  overflow: hidden;
  height: 100vh;
  width: 100%;

  position: relative;
  padding-top: calc(var(--header-main-height) + 3.5vw);
  @media screen and (max-width: 992px) {
    height: auto;
    padding-top: 7rem;
  }
  @media screen and (max-width: 767px) {
    padding-top: 5rem;
    height: 100%;
  }

  /* Portrait  IPad Pro*/
  @media only screen and (min-width: 1024px) and (orientation: portrait) {
    height: 60vh;
  }
  /* Portrait and Landscape */
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    padding-top: 7rem;

    .left-news__title {
      font-family: "Roboto";
      font-size: 1.2em;
      letter-spacing: 0.03em;
    }
    .left-news__descr {
      font-family: "Roboto";
      font-size: 1em;
      letter-spacing: 0.03em;
    }
    // .left-news__img {
    //   // height: 270px;
    // }
    .customers__title {
      font-size: 1.1em;
    }
    .customers__people {
      font-size: 1.8rem;
    }
  }
}
.shape-bottom {
  position: absolute;
  bottom: 30px;
  left: -179px;
  width: 288px;
  height: 288px;
  z-index: 0;
  @media screen and (max-width: 992px) {
    display: none;
  }
  img {
    display: block;
    background-color: transparent;
    transition: all 0.4s ease-in;
  }
}

.customers {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  &__people {
    width: 36px;
    height: 36px;
    margin-right: 1rem;
    font-size: 2em;
    @media screen and (max-width: 425px) {
      width: 20px;
      height: 20px;
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
  }
  &__title {
    font-size: 1.4em;
    @media screen and (max-width: 767px) {
      font-size: 1em;
    }
  }
  &__number {
    font-size: 1.6rem;
    font-weight: bold;
  }
}
.day {
  margin-right: 0.1rem;
}
.grid {
  margin-top: 10px;
  height: calc(100% - 9.1rem);
  display: grid;
  margin: 0 auto;
  max-width: 90%;
  grid-template-areas: "left center right";
  grid-template-columns: minmax(3.5vw, 1fr) 1fr minmax(5vw, 1fr);
  @media screen and (max-width: 992px) {
    grid-template-areas:
      "center right"
      "left left";
    grid-template-columns: 1fr 223px;
  }
  @media screen and (max-width: 767px) {
    grid-template-areas:
      "center"
      "right"
      "left ";
    grid-template-columns: 1fr;
  }

  &__left {
    max-width: calc(max(550px, 3.5vw));
    grid-area: left;
    position: relative;
    @media screen and (max-width: 992px) {
      max-width: 100%;
    }
  }
  &__center {
    .arrow-left {
      display: none;
      @media screen and (max-width: 425px) {
        cursor: pointer;
        display: block;
        position: absolute;
        right: 0;
        top: 100px;
        z-index: 10;
        transition: all 0.5s ease-in;
      }
    }

    position: relative;
    grid-area: center;
    overflow: visible;
    height: auto;

    .earth_cont {
      position: absolute;
      // height: 600px;
      width: calc(max(32vw, 650px));
      left: 50%;
      top: -10%;
      transform: translateX(-50%);
      transition: all 0.5s ease-in;
      @media screen and (max-width: 1920px) {
        top: 0%;
      }
      @media screen and (max-width: 1540px) {
        z-index: 0;
      }
      @media screen and (max-width: 1366px) {
        transform: translateX(-15%);
      }
      @media screen and (max-width: 1100px) {
        width: 500px;
      }
      @media screen and (max-width: 992px) {
        // max-width: 223px;
        height: 580px;
        width: 580px;
        transform: translateX(-54%);
        z-index: 0;
      }
      @media screen and (max-width: 767px) {
        height: 225px;
        width: 225px;
        transform: translateX(0%);
      }
      @media screen and (max-width: 425px) {
        transform: translateX(25%);
        height: 225px;
        width: 225px;
      }
    }
  }
  &__right {
    grid-area: right;
    // max-width: 378px;
    width: 100%;
    justify-self: end;
    z-index: 5;
    position: relative;
    .data-news {
      justify-content: center;
  font-size: 0.734em;

      @media screen and (max-width: 992px) {
        font-size: 13px;
        font-weight: normal;
        justify-content: flex-start;
      }
    }
    @media screen and (max-width: 992px) {
      display: block;
      max-width: 223px;
    }
    @media screen and (max-width: 767px) {
      max-width: 280px;
      justify-self: start;
      transition: all 0.5s ease-in;
    }
  }
}
.data-news {
  font-family: "Open Sans";
  font-size: 0.88em;
  margin-top: 6px;
  display: flex;
  @media screen and (max-width: 767px) {
    font-size: 10px;
    line-height: 14px;
    justify-content: flex-start;
  }
}

.left-news {
  display: flex;
  flex-direction: column;
  // max-width: 529px;
  width: 90%;
  position: relative;
  z-index: 1;
  @media screen and (max-width: 992px) {
    max-width: 95%;
    flex-direction: row;
    margin-top: 2rem;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  &__title {
    font-family: "Roboto";
    font-size: 1.5em;
    letter-spacing: 0.03em;
    @media screen and (max-width: 767px) {
      font-family: "Roboto";
      font-size: 1em;
      font-weight: 600;
      width: 80%;
      margin: 5px auto 0;
      text-align: center;
      .data-news {
        display: none;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .data-news {
      display: none;
    }
  }
  &__category {
    // text-align: right;
    opacity: 0.7;
    line-height: 1.5;
    display: flex;
    justify-content: space-between;
    .region {
      @media screen and (max-width: 992px) {
        display: none;
      }
    }
    @media screen and (max-width: 992px) {
      display: block;
      position: absolute;
      z-index: 1;
      padding: 0 5px;
      background: $green;
      opacity: 1;
    }
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__img {
    max-width: 85%;
    border-radius: 4px;
    margin-bottom: 1.1rem;
    overflow: hidden;
    .img {
      padding-bottom: 80%;
    }
    @media screen and (max-width: 992px) {
      margin-right: 10px;
      flex: 1 0 305px;
      height: 230px;
      position: relative;
    }
    @media screen and (max-width: 767px) {
      margin: 0;
      flex: 0 0 100%;
      min-height: 207px;
      min-width: 100%;
    }
    @media screen and (max-width: 425px) {
    }
  }
  &__descr {
    margin-top: 20px;
    font-family: "Roboto";
    font-size: 1.2em;
    line-height: 150%;
    margin-bottom: 5px;
    @media screen and (max-width: 767px) {
      margin-top: 0.5em;

      margin-bottom: 2rem;
      font-weight: 300;
      font-size: 12px;
    }
  }
}

.wrapper-right {
  transition: all 0.5s ease-in;
  overflow: hidden;
  height: calc(33vh * 2);
  width: 60%;
  margin-left: auto;
  @media screen and (max-width: 1366px) {
    display: none;
  }
  @media screen and (max-width: 992px) {
    margin-top: 4rem;
    overflow: visible;
    height: auto;
    display: block;
    width: 100%;
    margin-left: 0;
  }
  @media screen and (max-width: 767px) {
    margin-top: 0;
    flex-direction: column;
    justify-content: flex-end;
  }
  @media screen and (max-width: 425px) {
    height: auto;
    display: flex;
    flex-direction: column;
  }
}
.right-news {
  position: relative;
  margin-bottom: 1rem;
  width: 100%;
  height: 32vh;
  &__img {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    // height: 194px;
    max-width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .img {
      padding-bottom: 66%;
    }
    @media screen and (max-width: 992px) {
      height: 125px;
      max-width: 223px;
    }
    @media screen and (max-width: 767px) {
      height: 69px;
      min-width: 111px;
    }
  }
  &__title {
    font-family: Roboto;
    margin-top: 10px;
    text-align: center;
    font-size: 1.2em;
    line-height: 1.4;
    .limited-text {
      --snup: 2;
    }
    @media screen and (max-width: 992px) {
      font-family: "Open Sans";
      font-weight: 600;
      text-align: left;
      .limited-text {
        --snup: 4;
      }
    }
    @media screen and (max-width: 767px) {
      font-family: "Roboto";
      margin-top: 0;
      font-size: 1em;
      margin-left: 0.5rem;
      line-height: 1.1;
      font-weight: 500;
      width: 160px;
      .limited-text {
        font-size: 12px;
        line-height: 15px;
        font-weight: 500;
      }
      .data-news {
        font-size: 10px;
      }
    }
  }

  &__category {
    padding: 2px;
    position: absolute;
    top: 0;
    left: 10%;
    color: rgba(255, 255, 255, 0.7);
    background-color: $green;
    z-index: 1;
    @media screen and (max-width: 992px) {
      left: 0;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      position: relative;
      background: transparent;
    }

    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.news-bottom {
  display: flex;
  margin-top: auto;
  // padding: 0 0.2rem;
  background: $bg-white;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  // height: 115px;
  z-index: 2;
  position: relative;
  // max-width: 100%;
  overflow: hidden;
  @media screen and (max-width: 992px) {
    flex-direction: column;
    margin: 3.9rem 2.85rem;
    height: 100%;
    padding: 0 0.5rem;
    overflow: visible;
    .news-bottom-3 {
      .data-news {
        margin-left: auto;
      }
    }
  }

  @media screen and (max-width: 767px) {
    margin: 0;
    .news-bottom-3 {
      .data-news {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 425px) {
    margin: 0;
  }
}
.news {
  max-height: 115px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 25%;
  // margin: 0 0.2rem;
  transition: all 0.4s;
  // transform: translateX(-100%);
  @media screen and (max-width: 992px) {
    padding: 0;
    max-height: 100%;
    width: 100%;
    flex: 1 1 25%;
    &:nth-child(1) &__container {
      transform: translate(-25px);
    }
    &:nth-child(2) &__container {
      transform: translate(-25px);
    }
    &:nth-child(3) &__container {
      text-align: right;
      flex-direction: row-reverse;
      transform: translate(25px);
      .news__img {
        text-align: left;
      }
    }
    &:nth-child(4) &__container {
      text-align: right;
      flex-direction: row-reverse;
      transform: translate(25px);
      .news__img {
        text-align: left;
      }
    }
    &:nth-child(3) &__category {
      text-align: right;
    }
    &:nth-child(4) &__category {
      text-align: right;
    }
  }
  @media screen and (max-width: 767px) {
    &:nth-child(1) &__container {
      transform: translate(0px);
    }
    &:nth-child(2) &__container {
      transform: translate(0px);
    }
    &:nth-child(3) &__container {
      text-align: left;
      flex-direction: row;
      transform: translate(0);
    }
    &:nth-child(4) &__container {
      flex-direction: row;
      text-align: left;
      transform: translate(0);
      .news__img {
        text-align: left;
      }
    }
    &:nth-child(3) &__category {
      text-align: left;
    }
    &:nth-child(4) &__category {
      text-align: left;
    }
  }
  &__container {
    display: flex;
    gap: 0.5rem;
    padding: 0 0.5em;
  }
  &__category {
    color: #121212;
    font-family: "Open Sans";
    font-size: 0.9em;
    font-weight: 500;
    line-height: 1.5;
    padding: 0 0.5em;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__img {
    min-width: 112px;
    height: 84px;
    // padding: 0 0.2rem;

    @media screen and (max-width: 992px) {
      min-width: 221px;
      height: 135px;
      padding: 0;
    }
    @media screen and (max-width: 767px) {
      min-width: 111px;
      height: 69px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // padding: 0 10px;

    color: #121212;
    @media screen and (max-width: 992px) {
      width: 50%;
    }
    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }
  &__title {
    font-family: "Roboto";
    font-size: 1em;
    line-height: 1.2em;
    letter-spacing: 0.03em;
    font-weight: 500;
    @media screen and (max-width: 767px) {
      font-size: 12px !important;
    }
  }
  &__data {
    display: flex;
    flex-wrap: wrap;
    font-family: "Open Sans";
    line-height: 1.4rem;
    color: rgba(18, 18, 18, 0.7);
  }
}

.news-bottom-0 {
  width: 0%;
  // transform: translateX(100%);
  opacity: 1;
  transition: all 0.2s linear;
  @media screen and (max-width: 992px) {
    width: auto;
    transform: translateX(0);
    opacity: 1;
  }
}

.news-bottom-1,
.news-bottom-2 {
  .data-news {
    display: block;
  }
}
.news-bottom-5 {
  width: 0%;
  transform: translateX(-100%);
  opacity: 1;
  transition: all 0.4s linear;
}

.left-news-0 {
  position: absolute;
  top: 0;
  left: 0px;
  opacity: 1;
  transition: all 0.4s;
  z-index: 22;
  @media screen and (max-width: 992px) {
    position: relative;
    left: 0;
    opacity: 1;
  }
  @media screen and (max-width: 768px) {
    margin-left: auto;
    margin-right: auto;
  }
}
.left-news-1 {
  position: absolute;
  top: 0;
  left: 5%;
  opacity: 0;
  transition: all 0.4s;
}
.left-news-2 {
  transition: all 0.4s;
  position: absolute;
  left: -50%;
  opacity: 0;
}
.right-news-0 {
  transition: all 0.4s;
  transform: translateY(-31vw);
  height: 0;
  margin: 0;

  @media screen and (max-width: 992px) {
    display: none;
  }
}
.right-news-1 {
  @media screen and (max-width: 992px) {
    // display: none;
    height: auto;
  }
}
.right-news-2 {
  @media screen and (max-width: 992px) {
    // display: none;
    height: auto;
  }
}
.right-news-3 {
  @media screen and (max-width: 992px) {
    display: none;
    height: auto;
  }
}
.right-news-4 {
  @media screen and (max-width: 992px) {
    display: none;
  }
}
.right-news-5 {
  @media screen and (max-width: 992px) {
    display: none;
  }
}
.right-news-6 {
  @media screen and (max-width: 992px) {
    display: none;
  }
}
.animate-circule {
  position: absolute;
  right: -10%;
  top: 10%;
  z-index: 0;
  @media screen and (max-width: 1366px) {
    right: -40%;
    top: 10%;
  }
  @media screen and (max-width: 992px) {
    // display: none;
    top: 40%;
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
}
</style>
